export default "__VITE_ASSET__1328fbdd__"